(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class VideoOverlay extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-video-overlay-frame]');
      this.closeBtn = this.querySelector('[data-video-overlay-close]');
      this.lastOpener = null;

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this._onKeydown = this._onKeydown.bind(this);

      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close);

      this.addEventListener('click', (e) => {
        if (e.target === this) this.close();
      });
    }

    _embedSrc() {
      const id = this.dataset.videoId;
      const host = this.dataset.videoHost;
      if (!id) return '';
      if (host === 'youtube') {
        return 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
      }
      if (host === 'vimeo') {
        return 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0';
      }
      return '';
    }

    _mountFile() {
      if (!this.frame || this.frame.querySelector('video')) return;
      const tpl = this.frame.querySelector('[data-video-overlay-template]');
      if (!tpl) return;
      this.frame.appendChild(tpl.content.cloneNode(true));
      const video = this.frame.querySelector('video');
      if (video) {
        video.setAttribute('playsinline', '');
        video.play().catch(() => {});
      }
    }

    open(opener) {
      this.lastOpener = opener || null;

      if (this.dataset.videoHost === 'file') {
        this._mountFile();
      } else {
        const src = this._embedSrc();
        if (src && this.frame && !this.frame.querySelector('iframe')) {
          const iframe = document.createElement('iframe');
          iframe.setAttribute('src', src);
          iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
          iframe.setAttribute('allowfullscreen', 'allowfullscreen');
          this.frame.appendChild(iframe);
        }
      }

      // Pause the hero video while the overlay is open.
      const hero = document.querySelector(this.dataset.heroSelector + ' video');
      if (hero && !hero.paused) {
        this._heroWasPlaying = true;
        hero.pause();
      }

      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKeydown);
      if (this.closeBtn) this.closeBtn.focus();
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._onKeydown);

      // Stop playback by removing the iframe / video, but keep the file template for reuse.
      if (this.frame) {
        this.frame.querySelectorAll('iframe, video').forEach((el) => el.remove());
      }

      const hero = document.querySelector(this.dataset.heroSelector + ' video');
      if (hero && this._heroWasPlaying) {
        hero.play().catch(() => {});
        this._heroWasPlaying = false;
      }

      if (this.lastOpener && document.contains(this.lastOpener)) {
        this.lastOpener.focus();
      }
    }

    _onKeydown(e) {
      if (e.key === 'Escape') this.close();
    }
  }

  if (!customElements.get('video-overlay')) {
    customElements.define('video-overlay', VideoOverlay);
  }

  // Open trigger — delegated click on the action button.
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-video-overlay-open]');
    if (!opener) return;
    const id = opener.getAttribute('data-video-overlay-open');
    const overlay = id && document.getElementById(id);
    if (overlay && typeof overlay.open === 'function') {
      e.preventDefault();
      overlay.open(opener);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
